import jinshajiang from "./index.vue";
import jinshajiangHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

const gasClampWincc = () => import("./gasClamp_wincc.vue");
const gasClampPLC = () => import("./gasClamp_PLC.vue");
const gasClampSensor = () => import("./gasClamp_sensor.vue");
const gasClampCombined = () => import("./gasClamp_combined.vue");
const gasClampCombinedV2 = () => import("./gasClamp_combinedV2.vue");

const errorRecord = () => import("./../../components/ErrorRecordControl.vue");
const SimpleHumidityList = () => import("./../../components/SimpleHumidityList.vue");

const stationMainPLC = () => import("./station_main_plc.vue");
const stationAnchorPLC = () => import("./station_anchor_plc.vue");
const stationSaddlePLC = () => import("./station_saddle_plc.vue");
const stationMainWINCC = () => import("./station_main_wincc.vue");
const stationAnchorWINCC = () => import("./station_anchor_wincc.vue");
const stationSaddleWINCC = () => import("./station_saddle_wincc.vue");

const stationClampPLC = () => import("./stationClamp_PLC.vue"); 
const stationClampWINCC = () => import("./stationClamp_WINCC.vue"); 
const stationClampCombinedV2 = () => import("./stationClamp_combinedV2.vue"); 

export default [
  {
    path: "/jinshajiangIndex",
    name: "jinshajiangIndex",
    component: jinshajiangHome,
  },
  {
    path: "/jinshajiang/login",
    name: "jinshajiangLogin",
    component: login,
  },
  {
    path: "/jinshajiang",
    name: "jinshajiang",
    redirect: "/jinshajiang",
    component: jinshajiang,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "currentHumidityList",
        name: "currentHumidityList",
        component: SimpleHumidityList,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      {
        path: "gasClampWincc",
        name: "gasClampWincc",
        component: gasClampWincc,
      },
      {
        path: "gasClampPLC",
        name: "gasClampPLC",
        component: gasClampPLC,
      },
      {
        path: "gasClampSensor",
        name: "gasClampSensor",
        component: gasClampSensor,
      },
      {
        path: "gasClampCombined",
        name: "gasClampCombined",
        component: gasClampCombined,
      },
      {
        path: "gasClampCombinedV2",
        name: "gasClampCombinedV2",
        component: gasClampCombinedV2,
      },
            {
        path: "stationClampPLC",
        name: "stationClampPLC",
        component: stationClampPLC,
      },
      {
        path: "stationClampWINCC",
        name: "stationClampWINCC",
        component: stationClampWINCC,
      },
      {
        path: "stationClampCombinedV2",
        name: "stationClampCombinedV2",
        component: stationClampCombinedV2,
      },
      {
        path: "stationMainPlc",
        name: "stationMainPlc",
        redirect: "/jinshajiang/stationMainPlc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationMainPLC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationMainPLC,
          },
        ],
      },
      {
        path: "stationAnchorPlc",
        name: "stationAnchorPlc",
        redirect: "/jinshajiang/stationAnchorPlc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationAnchorPLC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationAnchorPLC,
          },
        ],
      },
      {
        path: "stationSaddlePlc",
        name: "stationSaddlePlc",
        redirect: "/jinshajiang/stationSaddlePlc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationSaddlePLC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationSaddlePLC,
          },
        ],
      },
      {
        path: "stationMainWincc",
        name: "stationMainWincc",
        redirect: "/jinshajiang/stationMainWincc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationMainWINCC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationMainWINCC,
          },
        ],
      },
      {
        path: "stationAnchorWincc",
        name: "stationAnchorWincc",
        redirect: "/jinshajiang/stationAnchorWincc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationAnchorWINCC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationAnchorWINCC,
          },
        ],
      },
      {
        path: "stationSaddleWincc",
        name: "stationSaddleWincc",
        redirect: "/jinshajiang/stationSaddleWincc/huaping",
        component: emptyComponent,
        children: [
          {
            path: "huaping",
            name: "huaping",
            component: stationSaddleWINCC,
          },
          {
            path: "lijiang",
            name: "lijiang",
            component: stationSaddleWINCC,
          },
        ],
      },
    ],
  },
];
